import React from 'react';
import Header, { IProps as HeaderIProps } from '@elements/header';

interface IProps extends HeaderIProps {
  children: HTMLDivElement | React.ReactNode;
}

export default function HeaderOnly(props: IProps) {
  const { children, isStickyHeader } = props;
  return (
    <>
      <Header isStickyHeader={isStickyHeader} />
      {children}
    </>
  );
}
